module.exports = __webpack_public_path__ + "site/img/Maps_1LongPing_bak.e261c481.jpg";